import Left from "@repo/icons/default/Left";
import {
  createFileRoute,
  useNavigate,
  useRouter,
  useSearch,
} from "@tanstack/react-router";
import { useState } from "react";
import type { ReactElement } from "react";
import { CpsButton, CpsCheckboxGroup, CpsCheckboxV2 } from "corpus";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import {
  type PatientPaymentsPageSearchSchema,
  patientPaymentsPageSearchSchema,
} from "@/lib/form-schemas/patient-payments-page-search-schema";

const FilterStatus = (): ReactElement => {
  const navigate = useNavigate();
  const router = useRouter();

  const navigateBack = (): void => {
    void router.navigate({
      to: "/settings/payments/patient-payments",
      search: { ...searchParams, back: (searchParams.back ?? 0) + 2, action: undefined },
    });
  };

  const searchParams = useSearch({
    from: "/settings/payments/patient-payments/filters/filter-status",
  });

  const [statusSelected, setStatusSelected] = useState<string[]>(
    searchParams.status ?? [],
  );

  const handleStatusChange = (values: string[]): void => {
    setStatusSelected(values);
  };

  const handleSubmit = (): void => {
    const newSearch: PatientPaymentsPageSearchSchema = {
      ...searchParams,
      back: (searchParams.back ?? 0) + 1,
      status: statusSelected,
    };
    void navigate({
      to: "/settings/payments/patient-payments",
      search: newSearch,
      replace: true,
    });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton onClick={navigateBack} align="start" icon={Left} />
        <HeaderTitle title="Filtro de status de pagamento" align="center" />
      </HeaderRoot>
      <Page className="flex flex-col justify-between">
        <CpsCheckboxGroup name="status-checkbox-group" onChange={handleStatusChange}>
          <CpsCheckboxV2
            value="paid"
            label="Pago"
            checked={statusSelected.includes("paid")}
          />
          <CpsCheckboxV2
            value="pending"
            label="Em aberto"
            checked={statusSelected.includes("pending")}
          />
          <CpsCheckboxV2
            value="canceled"
            label="Cancelado"
            checked={statusSelected.includes("canceled")}
          />
          <CpsCheckboxV2
            value="refunded"
            label="Estornado"
            checked={statusSelected.includes("refunded")}
          />
          <CpsCheckboxV2
            value="failed"
            label="Não autorizado"
            checked={statusSelected.includes("failed")}
          />
        </CpsCheckboxGroup>
        <CpsButton color="secondary" fullWidth onClick={handleSubmit}>
          Aplicar filtros
        </CpsButton>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/filters/filter-status",
)({
  component: FilterStatus,
  validateSearch: patientPaymentsPageSearchSchema,
});
